import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { StudentSummary } from '@starter/shared';
import { api, ApiError } from '../../api/client.js';
import { ErrorBanner } from '../../components/ErrorBanner.js';
import { LoadingState } from '../../components/LoadingState.js';
import { PageHeader } from '../../components/PageHeader.js';
import { StatusBadge } from '../../components/StatusBadge.js';

export function InstructorStudentsPage() {
  const [students, setStudents] = useState<StudentSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = () => {
    setLoading(true);
    setError(null);
    api
      .listStudents({ page: 1, pageSize: 100 })
      .then((res) => setStudents(res.data))
      .catch((err) => setError(err instanceof ApiError ? err.message : 'Failed to load students'))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <div className="page">
      <PageHeader title="Students" subtitle="Students in your program" />

      {error && <ErrorBanner message={error} onRetry={load} />}

      {loading ? (
        <LoadingState message="Loading students…" />
      ) : (
        <div className="card">
          {students.length === 0 ? (
            <p className="text-muted">No students found in your program.</p>
          ) : (
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Cohort</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((s) => (
                    <tr key={s.id}>
                      <td>
                        <Link to={`/instructor/students/${s.id}/documents`}>{s.fullName}</Link>
                      </td>
                      <td>{s.email}</td>
                      <td>{s.cohortName ?? '—'}</td>
                      <td>
                        {s.enrollmentStatus ? (
                          <StatusBadge status={s.enrollmentStatus} />
                        ) : (
                          '—'
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
